<template>
<div class="pass-verify">
  <input
    v-model="scanInput"
    name="scanInput"
    type="text"
    class="scanner-input"
    ref="scannerInput"
    autocomplete="off"
    autocapitalize="off"
    spellcheck="false"
    autofocus
    @keyup.enter="handleScan"
  />
  <div class="container header">
    <div class="row">
      <div class="col-lg-6 hidden-xs hidden-sm logo-container">
        <img src="../../../../public/img/konversta.png" alt class="img-logo" />
      </div>
      <div class="col-lg-6 col-xs-12 user-container">
        <div v-if="user.name" class="user"><div class="user-avatar">{{ initials }}</div>{{ user.name }}</div>
        <button class="btn btn-outline-primary btn-primary-blue logout-btn" @click="logout">
          Выйти из кабинета&nbsp;<img src="../../../../public/img/icons/sign-out.svg" alt="">
        </button>
      </div>
    </div>
  </div>

  <div
    class="main-container"
    :style="{
      'margin-bottom': !passExists ? '100px' : '20px',
  }"
  >
    <div v-if="loading" class="row">
      <div class="col-md-12 error-container">
        <img src="../../../../public/img/icons/load.svg" alt="forbidden pass image" class="error-img loading-spinner" />
        <h2>Ищем пропуск...</h2>
        <p>Это может занять пару минут</p>
      </div>
    </div>

    <div v-else-if="!passExists" class="row">
      <div v-if="errors[403]" class="col-md-12 error-container">
        <img src="../../../../public/img/forbidden.svg" alt="forbidden pass image" class="error-img" />
        <h2 v-html="'Нет&nbsp;доступа'" class="fw-bold"></h2>
        <p>У вас нет доступа к сканированию пропусков</p>
        <p>Если считаете, что это ошибка, то обратитесь к своему администратору</p>
      </div>
      <div v-else-if="errors[404]" class="col-md-12 error-container">
        <img src="../../../../public/img/travolta.png" alt="not found pass image" class="error-img" />
        <h2 v-html="'Пропуск не&nbsp;найден'" class="fw-bold"></h2>
        <p>Попробуйте отсканировать ещё раз или используйте другой пропуск</p>
      </div>
      <div v-else class="col-md-12 error-container">
        <img src="../../../../public/img/scan.svg" alt="scan image" class="error-img" />
        <h2 v-html="'Начните&nbsp;сканирование'" class="fw-bold"></h2>
        <p>Для получения информации поднесите пропуск к считывателю</p>
      </div>
    </div>

    <div v-else>
      <div class="fw-bold full-name">{{ pass.fullName }}</div>
      <div class="last-action-text">{{ lastActionText }}</div>

      <div
        class="pass-data-container"
        :style="{ 'border': passPeriodStatus === 'active' ? '#1BC47D 2px solid' : '#D61C38 2px solid' }"
      >
        <div class="row pass-data">
          <div
            v-html="passPeriodText"
            class="col-sm-8 col-xs-12"
            :style="{ 'color': passPeriodStatus !== 'active' ? '#D61C38' : '' }"
            style="line-height: 24px"
          />
          <div class="col-sm-4 col-xs-12">
            <div
              class="pass-number"
              :style="{
                'color': passPeriodStatus !== 'active' ? '#D61C38' : '',
                'background-color': passPeriodStatus === 'active' ? '#F0F3F8' : '#FF383C24'
              }"
            >
              № пропуска {{ pass.number }}
              <div
                class="scan-info-container hidden-xs hidden-sm hidden-md"
                :style="{ 'margin-top': !lastActionText ? '-103px' : '-123px' }"
              >
                <img src="../../../../public/img/scan.svg" alt="scan image" class="scan-info-img" />
                <br>
                Для нового сканирования поднесите пропуск к считывателю
              </div>
            </div>
            <div
              v-if="pass.cardCode"
              class="pass-card-code"
              :style="{
                'color': passPeriodStatus !== 'active' ? '#D61C38' : '',
                'background-color': passPeriodStatus === 'active' ? '#F0F3F8' : '#FF383C24'
              }"
            >
              Код карты {{ pass.cardCode }}
            </div>
          </div>
        </div>
      </div>

      <div class="personal-data-container">
        <div class="row title">
          <div class="col-md-12 fw-bold">{{ pass.identificationType }}</div>
        </div>

        <div class="row">
          <div class="col-md-12 data">
            <div class="col-md-2 col-lg-3 avatar-container"><img :src="passAvatar" alt="avatar" class="avatar" /></div>
            <div class="col-md-10 col-lg-9 personal">
              <div class="row">
                <div class="col-xs-5">Серия и номер</div><div class="col-xs-7">{{ pass.identificationNumber }}</div>
              </div>
              <div class="row">
                <div class="col-xs-5">Кем выдан</div>
                <div class="col-xs-7">{{ pass.identificationPlace }}</div>
                <div class="col-xs-5" style="color: #1E222E8F">Код подразделения</div>
                <div class="col-xs-7" style="color: #1E222E8F">{{ pass.identificationCode }}</div>
              </div>
              <div class="row">
                <div class="col-xs-5">Дата выдачи</div><div class="col-xs-7">{{ pass.identificationDateOf }}</div>
              </div>
              <div v-if="pass.identificationDateTo" class="row">
                <div class="col-xs-5">Дата окончания</div><div class="col-xs-7">{{ pass.identificationDateTo }}</div>
              </div>
              <div class="row">
                <div class="col-xs-5">Дата рождения</div><div class="col-xs-7">{{ pass.birthDay }}</div>
              </div>
              <div class="row">
                <div class="col-xs-5">Адрес регистрации</div><div class="col-xs-7">{{ pass.registrationAddress }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="pass.transports.length > 0" class="transport-data-container" style="margin-top: 15px">
        <div class="row title">
          <div class="col-md-12 fw-bold">Транспортное средство</div>
        </div>

        <div class="row">
          <div class="col-md-12 data">
            <div v-for="transport in pass.transports" :key="transport.id" class="transport-container">
              <div class="col-lg-12 fw-bold transport-type-name">{{ transport.typeName }}</div>
              <div class="col-md-2 col-lg-3 avatar-container">
                <img
                  :src="'../img/icons/transports/pass-verify/' + transport.type + '.svg'"
                  :alt="transport.type"
                  class="avatar"
                />
              </div>
              <div class="col-md-10 col-lg-9 transport">
                <div class="row">
                  <div class="col-xs-5">ГРЗ или VIN</div><div class="col-xs-7">{{ transport.number }}</div>
                </div>
                <div class="row">
                  <div class="col-xs-5">Марка, модель, цвет</div>
                  <div class="col-xs-7">{{ transport.mark }}, {{ transport.model }}, {{ transport.color }}</div>
                </div>
                <div class="row">
                  <div class="col-xs-5">Собственник</div><div class="col-xs-7">{{ transport.owner }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-if="visibleAllowButton" class="sticky-btn-container">
    <div class="btn-container">
      <button
        v-html="buttonTextByLastActionType"
        class="btn btn-primary btn-primary-blue allow-btn"
        @click="allowAction"
      />
    </div>
    <div class="scan-info-container hidden-lg">
      <img src="../../../../public/img/scan.svg" alt="scan image" class="scan-info-img" />
      <div class="scan-info-text">Для нового сканирования поднесите пропуск к считывателю</div>
    </div>
  </div>

  <div v-else-if="!loading && passExists" class="scan-info-container hidden-lg">
    <img src="../../../../public/img/scan.svg" alt="scan image" class="scan-info-img" />
    <div class="scan-info-text">Для нового сканирования поднесите пропуск к считывателю</div>
  </div>
</div>
</template>

<script>
import mainMixin from '@/common/mixins/mainMixin'
import { ApiClient } from '@/common/helpers/api-client/ApiClient'
import '@/common/assets/styles/pass-verify.scss'
import PermissionsEnum from '@/common/enums/PermissionsEnum'
import PermissionsMixin from '@/common/mixins/PermissionsMixin'
import { ResponseStatuses } from '@/enums/ResponseStatuses'

export default {
  name: 'PassVerify',

  mixins: [mainMixin, PermissionsMixin],

  data() {
    return {
      baseUrl: window.location.origin + window.location.pathname,
      loading: true,
      errors: '',
      scanInput: '',
      showAllowButton: true,
      pass: {
        id: this.$route.query.passId,
        number: '',
        cardCode: this.$route.query.cardCode,
        periodOf: '',
        periodTo: '',
        fullName: '',
        identificationType: '',
        identificationNumber: '',
        identificationCode: '',
        identificationPlace: '',
        identificationDateOf: '',
        identificationDateTo: '',
        birthDay: '',
        registrationAddress: '',
        avatar: '',
        lastActionType: '',
        lastActionDate: '',
        transports: {
          id: '',
          type: '',
          typeName: '',
          number: '',
          mark: '',
          model: '',
          color: '',
          owner: ''
        }
      }
    }
  },

  computed: {
    buttonTextByLastActionType() {
      if (!this.pass || !['in', 'out'].includes(this.pass.lastActionType) || this.pass.lastActionType === 'out') {
        return 'Разрешить вход&nbsp;<img src="../img/icons/enter.svg" alt="">'
      }

      return 'Разрешить выход&nbsp;<img src="../img/icons/exit.svg" alt="">'
    },

    initials() {
      if (this.user.name === null || this.user.name === '') {
        return ''
      }

      const first = this.user.name.split(' ')[0]
      const last = this.user.name.split(' ')[1]

      if (first && last) {
        return `${first.charAt(0).toUpperCase()}${last.charAt(0).toUpperCase()}`
      } else if (first) {
        return first.charAt(0).toUpperCase()
      } else if (last) {
        return last.charAt(0).toUpperCase()
      }

      return ''
    },

    lastActionText() {
      if (this.pass.lastActionDate === null) {
        return ''
      }

      let lastActionText = 'Последний ' + (this.pass.transports.length === 0 ? 'вход' : 'въезд')
      if (this.pass.lastActionType === 'out') {
        lastActionText = 'Последний ' + (this.pass.transports.length === 0 ? 'выход' : 'выезд')
      }

      return lastActionText + ' был ' + this.pass.lastActionDate.replace(' ', ' в ')
    },

    passAvatar() {
      return this.pass.avatar !== null ? this.pass.avatar : '../img/no-photo.svg'
    },

    passExists() {
      return this.pass && ![undefined, null, ''].includes(this.pass.id)
    },

    passPeriodStatus() {
      const now = new Date()
      const periodOf = new Date(this.getIsoDate(this.pass.periodOf))
      const periodTo = new Date(this.getIsoDate(this.pass.periodTo))

      if (now < periodOf) {
        return 'not_started'
      }

      if (periodTo < now) {
        return 'expired'
      }

      return 'active'
    },

    passPeriodText() {
      const periodOf = this.pass.periodOf.replace(' ', '&nbsp;')
      const periodTo = this.pass.periodTo.replace(' ', '&nbsp;')
      const datePeriod = 'с&nbsp;<span class="fw-bold">' + periodOf + '</span>' +
        ' по&nbsp;' + '<span class="fw-bold">' + periodTo + '</span>'

      let text = 'Пропуск действует&nbsp;<img src="../img/icons/check.svg" alt="">'
      if (this.passPeriodStatus === 'not_started') {
        text = 'Не наступил срок действия пропуска' +
          '&nbsp;<img src="../img/icons/cancel-filled.svg" alt="">'
      }

      if (this.passPeriodStatus === 'expired') {
        text = 'Истёк срок действия пропуска&nbsp;<img src="../img/icons/cancel-filled.svg" alt="">'
      }

      return text + '<br>' + datePeriod
    },

    userCanUse() {
      return this.hasPermission(PermissionsEnum.canUsePassVerifyPage)
    },

    visibleAllowButton() {
      return !this.loading && this.passExists && this.userCanUse &&
        this.showAllowButton && this.passPeriodStatus === 'active'
    }
  },

  methods: {
    allowAction() {
      let action = 'in'
      if (this.pass.lastActionType === 'in') {
        action = 'out'
      }

      ApiClient.passAllowAction({ passId: this.pass.id, action: action })
        .then((result) => {
          if (result.data.status === 'success') {
            this.showAllowButton = false
            this.loadPage()
          }
        })
    },

    focusScanner() {
      this.$refs.scannerInput.focus()
    },

    handleScan() {
      let input = this.scanInput.trim()

      if (!input) {
        this.scanInput = ''

        return
      }
      let decodedInput = decodeURIComponent(input)

      let targetLocation = ''
      if (input.startsWith('http://') || input.startsWith('https://')) {
        const urlObj = new URL(input)
        urlObj.protocol = window.location.protocol
        if (urlObj.origin === window.location.origin) {
          targetLocation = urlObj.toString()
        }
      } else if (decodedInput.startsWith('http://') || decodedInput.startsWith('https://')) {
        const urlObj = new URL(decodedInput)
        urlObj.protocol = window.location.protocol
        if (urlObj.origin === window.location.origin) {
          targetLocation = urlObj.toString()
        }
      }

      if (targetLocation === '') {
        targetLocation = this.baseUrl + '?cardCode=' + input
      }

      window.location.href = targetLocation
      this.scanInput = ''
    },

    getIsoDate(date) {
      const [datePart, timePart] = date.split(' ');
      const [day, month, year] = datePart.split('.');

      return `${year}-${month}-${day}T${timePart}`
    },

    async loadPage() {
      let params = { passId: this.pass.id }
      if (![undefined, null, ''].includes(this.pass.cardCode)) {
        params = { cardCode: this.pass.cardCode }
      }

      await ApiClient.getPassVerify(params)
        .then((result) => {
          if (result.data.http_code === 200) {
            this.pass = result.data.data
            this.errors = result.data.errors
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    logout() {
      ApiClient.logout()
        .then(response => {
          if (response.data.status === ResponseStatuses.Success) {
            this.$store.dispatch('flushAuthorize')
            window.location.reload()
          }
        })
    }
  },

  mounted() {
    this.loadPage()
    this.hidePreloader()
    document.addEventListener('click', this.focusScanner)
  }
}
</script>
